import { gql } from 'graphql-tag'

export const activityDetailReport = gql`
  query ActivityDetailReport($entityIds: [Int]!, $activityId: Int!) {
    me {
      id
      serverDateTime
      teacher {
        id
        activityDetailReport(activityId: $activityId, entityIds: $entityIds)
      }
    }
    getActivity(activityId: $activityId) {
      id
      title
    }
  }
`

export const adminSearchAtualidadesActivities = gql`
  query adminSearchAtualidadesActivities(
    $page: Int!
    $perPage: Int!
    $searchTerm: String!
  ) {
    adminSearchAtualidadesActivities(
      searchTerm: $searchTerm
      page: $page
      perPage: $perPage
    ) {
      activities {
        degreeRange
        id
        moduleId
        title
        examQuestions {
          type
        }
        articles {
          id
          image
          title
        }
      }
      totalEntries
    }
  }
`

export const selectEntityQuery = gql`
  query SelectEntityQuery {
    me {
      id
      teacher {
        id
        permissions
        teacherEntities
        showFlag
      }
    }
  }
`

export const getActivityQuery = gql`
  query listAppliedActivityDetails($activityId: Int!) {
    me {
      id
      teacher {
        id
        listAppliedActivityDetails(activityId: $activityId) {
          activityTitle
          others {
            status
          }
          entities
        }
      }
    }
  }
`

// export const listManageableFeaturesQuery = gql`
//   query listManageableFeatures {
//     listManageableFeatures {
//       id
//       title
//       description
//       active
//       image
//     }
//   }
// `

export const listManageableFeaturesQuery = gql`
  query Teste1 {
    me {
      id
    }
  }
`

export const readerYearlyIndicators = gql`
  query readerYearlyIndicators(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $readerId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    readerSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      readerId: $readerId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      yearlyIndicators {
        monthlyCompletedActivitiesCount {
          completedActivitiesCount
          referenceMonth
        }
        monthlyReadingsCount {
          readingsCount
          referenceMonth
        }
      }
    }
  }
`

export const teacherYearlyIndicators = gql`
  query teacherYearlyIndicators(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $teacherId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    teacherSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      teacherId: $teacherId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      yearlyIndicators {
        monthlyReviewedActivitiesCount {
          referenceMonth
          reviewedActivitiesCount
        }
        monthlyIndicationsCount {
          indicationsCount
          referenceMonth
        }
      }
    }
  }
`

export const readerProgressBnccAbilities = gql`
  query readerProgressBnccAbilities(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $readerId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    readerSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      readerId: $readerId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      performanceIndicators {
        progressBnccAbilities {
          ability
          abilityDescription
          totalCorrectObjectiveQuestionsCount
          totalObjectiveQuestionsCount
        }
      }
    }
  }
`

export const readerMostReadContents = gql`
  query readerMostReadContents(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $readerId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    readerSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      readerId: $readerId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      performanceIndicators {
        mostReadContents {
          author
          contentId
          contentType
          thumbUrl
          title
        }
      }
    }
  }
`

export const activitiesReaderQuery = gql`
  query activitiesReaderQuery(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $readerId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    readerSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      readerId: $readerId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      performanceIndicators {
        completedActivitiesCountToDate
        startedActivitiesCountToDate
        hitsPerQuestionToDate
      }
    }
  }
`

export const activitiesTeacherQuery = gql`
  query activitiesTeacherQuery(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $teacherId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    teacherSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      teacherId: $teacherId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      performanceIndicators {
        assignedActivitiesCountByDifficulty {
          count
          difficultyLevel
        }
        mostAssignedBnccCompetencies {
          competency
          count
        }
        assignedQuestionsCountByKind {
          count
          kind
        }
        assignedActivitiesCount
        startedActivitiesCount
        pendingReviewActivitiesCount
        reviewedActivitiesCount
      }
    }
  }
`

export const readerAccessCount = gql`
  query readerAccessCount(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $readerId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    readerSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      readerId: $readerId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      usageTimeIndicators {
        learningTimeInMinutes
      }
    }
  }
`

export const teacherAccessCount = gql`
  query teacherAccessCount(
    $classId: Int
    $holdingId: Int
    $networkId: Int
    $teacherId: Int!
    $referenceDate: IsoDate!
    $schoolId: Int
    $trademarkId: Int
  ) {
    teacherSummaryReport(
      classId: $classId
      holdingId: $holdingId
      networkId: $networkId
      teacherId: $teacherId
      referenceDate: $referenceDate
      schoolId: $schoolId
      trademarkId: $trademarkId
    ) {
      usageTimeIndicators {
        platformUsageTimeInMinutes
      }
    }
  }
`

export const listCollectionsQuery = gql`
  query listCollections {
    listCollections {
      id
      name
    }
  }
`

export const fetchBooksByCollectionAndBookCollectionQuery = gql`
  query fetchBooksByCollectionAndBookCollection(
    $collectionId: Int
    $bookCollectionId: Int
  ) {
    fetchBooksByCollectionAndBookCollection(
      collectionId: $collectionId
      bookCollectionId: $bookCollectionId
    ) {
      id
      name
      author
      slug
      publicationYear
      isbn
      publisher {
        name
      }
    }
  }
`

export const adminListBookActivitiesQuery = gql`
  query adminListBookActivities($bookSlug: String!) {
    adminListBookActivities(bookSlug: $bookSlug) {
      hasActivitiesToShow
      id
      title
      status
      questions {
        id
        type
        title
        isCorrect
        pageReference
        matchingPairs {
          id
          statement
          leftId
          leftStatement
          rightId
          rightStatement
          __typename
        }
        answer {
          id
          answerDiscursive
          answerChoiceId
          examQuestionId
          teacherComments
          grade
          isCorrect
          correctAnswerId
          __typename
        }
        choices {
          id
          title
          isCorrect
          __typename
        }
        __typename
      }
      __typename
    }
  }
`
